import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';
import {NavLink} from 'react-router-dom';
import {Presentation} from 'apa/containers/Presentation';
import Loading from 'apa/components/Loading';
import {Container} from 'reactstrap';

@connect(
    state => ({
        errors: state.apa.errors,
        user: state.apa.user,
        isAuthenticated: state.apa.isAuthenticated,
        isLoading: state.apa.isLoading
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)

export default class Home extends Component {
    state = {
        hasEnded: false
    }
    constructor(props) {
        super(props);
    }
    @autobind
    onSubmit(event) {
        event.preventDefault();
        const {
            username,
            password
        } = this.state;
        this.props.login(username, password)
    }

    @autobind
    endPresentation() {
        this.setState({
            hasEnded: true
        })
    }  

    render() {
        if(this.props.user.access_code?.status === 1 && this.props.user.access_code?.attempts === 0 || this.props.user.access_code?.status === 2 || this.props.user.access_code?.status === 3) {
            return <Redirect to={'/training/status'} />
        }
        if(this.props.isLoading)
            return <Loading/>;
        const slides = this.props.user.access_code.training.presentation_slides || [];
        const customer_name = this.props.user.access_code.training.customer_name;
        const training_name = this.props.user.access_code.training.name;
        const attempts =this.props.user.access_code.attempts
        const status = this.props.user.access_code.status;

        return (
            <Container>
                <h1>
                    { customer_name }
                </h1>
                <h2>
                    { training_name }
                </h2>
                {console.log("status", status)}
                {status == 4 ? (
               <p>
                 Die Präsentation ist gesperrt, da Sie den Testversuch gestartet und noch nicht eingereicht haben.
               </p>
                ):(
                <Presentation updateCurrentSlide={true} items={slides} endPresentation={this.endPresentation}/>
                )}
                {
                    status == 4 || this.state.hasEnded ?(
                    status==0 || status == 4 ?(
                    <p className='text-center'>
                        <NavLink to="/training/test/">Zu den Testfragen</NavLink>
                    </p>
                    ):(
                        status==2 && attempts > 0 || status==1 && attempts > 0 ?
                        (
                        <p className='text-center'>
                            <NavLink to="/training/test/">Zu den Testfragen</NavLink>
                        </p>
                        ):(
                        <p className='text-center'>
                            <NavLink to="/training/status/">Sehen Sie sich Ihr Testergebnis an</NavLink>
                       </p>
                        )
                    )
                    ): null
                }
            </Container>
        )
    }
}

Home.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
